import { GetCart, GetTotal, ClearCart, GetCount } from './CartHandler';
import { confirm } from "react-confirm-box";
import { useState, useEffect, useRef } from 'react';
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import "./addressModal.css";
import Swal from "sweetalert2";

import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Fullscreen } from '@mui/icons-material';


const apiUrl = process.env.REACT_APP_BASEURL;


function PaymentBlock(props) {

    const [purchaseClicked, setPurchaseClicked] = useState(false);
    const [orderType, setOrderType] = useState(null);
    const [orderNumber, setOrderNumber] = useState(null);
    const [cart, setCart] = useState({});
    const [requirePO, setRequirePO] = useState(false);
    const [clientOrder, setClientOrder] = useState(false);
    const [quoteClicked, setQuoteClicked] = useState(false);
    const [isOrderNumberFetched, setIsOrderNumberFetched] = useState(false); // New state to track order number fetch

    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const navigate = useNavigate();



    // const getNewOrderNumber = () =>{
    //     console.log("Here is your token In Payment Block at GetNewOrderNumber: "+ props.token.token)
    //     axios
    //     .get(apiUrl + `/api/Orders/GetOrderNumber?orderType=3&oldOrderNumber=${orderNumber}`, {
    //         headers: headers
    //                 })
    //     .then((response) => {
    //       console.log("PaymentBlock getNewOrderNumber Data:  ", response.data);
    //       setOrderNumber(response.data);

    //     })
    //     .catch((error) => {
    //       console.log(error);
    //     });
    // }



    // const getRequirePO3 = () => {
    //     try {
    //         axios.get(apiUrl + `/api/Users/GetPoRequired?type=3`, {
    //             headers: headers
    //         })
    //             .then((response) => {
    //             console.log("PaymentBlock getRequiredPO3 Data:", response.data);

    //                 setRequirePO(response.data);

    //             })
    //             .catch((error) => {
    //             console.log(error);
    //             });
    //         } catch (error) {
    //         console.log(error);
    //         }
    //     };

    let headers = {
        "Accept": "application/json",
        "Content-Type": "application/json",
        'Authorization': 'Bearer ' + props.token.token
    };

    const mounted = useRef()

    // const saveTransaction = () =>{
    //     try {
    //         axios.post(apiUrl + `/api/Payments/PersistTransaction`,JSON.stringify(transaction), {
    //             headers: headers
    //         })
    //             .then((response) => {
    //             console.log("PaymentBlock saveTransaction Data:", response.data);

    //             })
    //             .catch((error) => {
    //             console.log(error);
    //             });
    //         } catch (error) {
    //         console.log(error);
    //         }
    // }


    const options = {
        labels: {
            confirmable: "OK",
            cancellable: ""
        }
    }
    // Function to set orderType and trigger the fetching of order number
    function quoteClick() {
        console.log("Setting orderType to 1 (quote)");
        setOrderType(1); // Updates order type to quote
        setIsOrderNumberFetched(false); // Reset flag
    }

    function orderClick() {
        console.log("Setting orderType to 2 (order)");
        setOrderType(2); // Updates order type to order
        setIsOrderNumberFetched(false); // Reset flag
    }

    function invoiceClick() {
        console.log("setting invoiceType to 3");
        setOrderType(3);
        setIsOrderNumberFetched(false);
    }

    // Effect to fetch order number when orderType changes
    useEffect(() => {
        console.log(`YOO this the order type: ${orderType}`);

        // Check if orderType is a valid number (1 for quote, 2 for order)
        if (orderType !== null && (orderType === 1 || orderType === 2 || orderType === 3)) {
            axios
                .get(apiUrl + `/api/Orders/GetOrderNumber?orderType=${orderType}`, {
                    headers: {
                        "Accept": "application/json",
                        "Content-Type": "application/json",
                        'Authorization': 'Bearer ' + props.token.token,
                    },
                })
                .then((response) => {
                    console.log("Received Order Number Data: ", response.data);
                    setOrderNumber(response.data); // Set order number
                    setIsOrderNumberFetched(true); // Mark as fetched
                })
                .catch((error) => {
                    console.log(error);
                });
        } else {
            console.log("Invalid or null orderType!");
        }
    }, [orderType]); // Only runs when orderType changes

    // Effect to execute methods after orderType is set and order number is fetched
    useEffect(() => {
        if (isOrderNumberFetched) { // Only run if the order number has been fetched
            if (orderType === 1) {
                console.log(`Order type updated to: ${orderType} (quote)`);
                setTimeout(() => {
                    quoteClickMethod(); // Triggers method after the state is updated
                }, 1000);
            } else if (orderType === 2) {
                console.log(`Order type updated to: ${orderType} (order)`);
                setTimeout(() => {
                    purchaseClickMethod(); // Triggers method after the state is updated
                }, 1000);
            } else if (orderType === 3) {
                console.log(`Order type updated to: ${orderType} (invoice)`);
                setTimeout(() => {
                    invoiceClickMethod(); // Triggers method after the state is updated
                }, 1000);
            }
        }
    }, [isOrderNumberFetched, orderType]); // Runs when order number is fetched or orderType changes

    const quoteClickMethod = () => {
        console.log(`Executing quoteClickMethod with orderType: ${orderType}`);
        if (requirePO === true && props.customerPO === null) {
            alert("A PO Number is required. Please Enter a PO Number.");
        } else {
            if (props.customerPO !== null) {
                submitOrderPO();
                OrderSavedClear();
            } else {
                submitOrderNoPO();
                OrderSavedClear();
            }
        }
    };

    const purchaseClickMethod = () => {
        console.log(`Executing purchaseClickMethod with orderType: ${orderType}`);
        if (requirePO === true && props.customerPO === null) {
            alert("A PO Number is required. Please Enter a PO Number.");
        } else {
            if (props.customerPO !== null) {
                submitOrderPO();
                OrderSavedClear();
            } else {
                submitOrderNoPO();
                OrderSavedClear();

            }
        }
    };

    const invoiceClickMethod = () => {
        console.log(`Executing invoiceClickedMethod with orderType: ${orderType}`);
        if (requirePO === true && props.customerPO === null) {
            alert("A PO Number is required. Please Enter a PO Number.");
        } else {
            if (props.customerPO !== null) {
                submitOrderPO();
                OrderSavedClear();
            } else {
                submitOrderNoPO();
                OrderSavedClear();
            }
        }
    };


    const getRequirePO2 = () => {
        try {
            axios.get(apiUrl + `/api/Users/GetPoRequired?type=2`, {
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    'Authorization': 'Bearer ' + props.token.token
                },
            })
                .then((response) => {
                    // console.log("PaymentBlock getRequiredPO2 Data:", response.data);
                    setRequirePO(response.data);

                })
                .catch((error) => {
                    console.log(error);
                });
        } catch (error) {
            console.log(error);
        }
    };


    function OrderSavedClear() {
        ClearCart();
        props.setCartCount(GetCount());
        props.onRequestClose();

    };


    const submitOrderPO = () => {

        console.log("You are here in PaymentBlock.submitOrderPo sending : ", cart);

        if (orderType === 3) {
            Swal.fire({
                title: "Success!",
                text: "Invoice has been submitted, thank you.",
                icon: "success",
                confirmButtonText: "OK"
            });
        } else if (orderType === 2) {
            Swal.fire({
                title: "Success!",
                text: "Order has been submitted, thank you.",
                icon: "success",
                confirmButtonText: "OK"
            });
        } else if (orderType === 1) {
            Swal.fire({
                title: "Success!",
                text: "Quote has been submitted, thank you.",
                icon: "success",
                confirmButtonText: "OK"
            });
        }


        try {
            axios.post(apiUrl + `/api/Orders/AddInvoice?orderNumber=${orderNumber}&orderType=${orderType}&poNumber=${props.customerPO}&freight=${props.shipping}`, cart, {
                headers: headers
            })
                .then((response) => {
                    // console.log("PaymentBlock submitOrderPO Data:", response.data);

                })
                .catch(function (error) {
                    if (error.response) {
                        console.log(error.response.data);
                        console.log(error.response.status);
                        console.log(error.response.headers);
                    } else if (error.request) {
                        // console.log("The request was made but no response was received");
                        // console.log("`error.request` is an instance of XMLHttpRequest in the browser and an instance of");
                        // console.log("http.ClientRequest in node.js");    
                        console.log(error.request);
                    } else {
                        console.log("Something happened in setting up the request that triggered an Error");
                        console.log('Error', error.message);
                    }
                });
        } catch (error) {
            console.log(error);
        }
        navigate("/");

    };



    const submitOrderNoPO = async () => {
        console.log("You are here in PaymentBlock.submitOrderNoPo sending : ", cart);
        console.log(`Order number: ${orderNumber}`);
        console.log(`shipping: ${props.shipping}`);
        console.log(`Order type: ${orderType}`);

        if (orderType === 3) {
            Swal.fire({
                title: "Success!",
                text: "Invoice has been submitted, thank you.",
                icon: "success",
                confirmButtonText: "OK"
            });
        } else if (orderType === 2) {
            Swal.fire({
                title: "Success!",
                text: "Order has been submitted, thank you.",
                icon: "success",
                confirmButtonText: "OK"
            });
        } else if (orderType === 1) {
            Swal.fire({
                title: "Success!",
                text: "Quote has been submitted, thank you.",
                icon: "success",
                confirmButtonText: "OK"
            });
        }


        try {
            const response = await axios.post(apiUrl + `/api/Orders/AddInvoice?orderNumber=${orderNumber}&orderType=${orderType}&freight=${props.shipping}`, cart, {
                headers: headers
            });

            console.log("PaymentBlock submitOrderNoPO Data:", response.data);

        } catch (error) {
            if (error.response) {
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
            } else if (error.request) {
                console.log(error.request);
            } else {
                console.log("Something happened in setting up the request that triggered an Error");
                console.log('Error', error.message);
            }
        }
        navigate("/");

    };



    const [total, setTotal] = useState();
    const [transaction, setTransaction] = useState("");

    // const updateInputValue = (evt) =>{
    //     console.log("Credit Card Changed");
    //     setCCNumber(evt.target.val);
    // };


    // const verifyCard=() =>{

    //uncomment for credit card processing testing and go live.

    // console.log('you would be sending the following payment info: ', ccPayment);
    // console.log('Uncomment verifyCard() in PaymentBlock.js to go live with this feature....');
    // setCCNumber('');
    // setTransaction('Transaction Data From API Here');
    // try {
    //     axios.post(apiUrl + `/api/Payments/VerifyCard?amount=${total}`,JSON.stringify(ccPayment), {
    //         headers: headers
    //     })
    //         .then((response) => {
    //         console.log("PaymentBlock verifyCard Data:", response.data);
    //         let trns = response.data
    //         if (response.authCode === '') {
    //             setCCNumber('');
    //         } else {
    //             setTransaction(response.data);
    //         }
    //         })
    //         .catch((error) => {
    //         console.log(error);
    //         });
    //     } catch (error) {
    //     console.log(error);
    //     }
    // };

    const [year, setYear] = useState((new Date()).getFullYear());
    const [years, setYears] = useState(Array.from(new Array(10), (val, index) => index + year));


    useEffect(() => {
        setCart(GetCart());
        getRequirePO2();
        setTotal(props.orderTotal);
        // console.log("PaymentBlock.UseEffect Cart: ",cart);
    }, []);



    // Call the function when needed



    const paymentBlockConditionalRender = () => {

        //         if(props.paymentMethod==='CREDIT CARD'){
        //         return(
        //         <div id="checkout" className="fill">
        //             <h1>Payment</h1>          
        //             <div className="row">
        //                 <input type="text" id="name" placeholder="Name on Card"  />
        //                 <input type="text" id="cardNumber" placeholder="Card Number" value={ccNumber} onChange={evt => updateInputValue(evt)}/>
        //                 <span>
        //                     <label>{'Expiration: '}</label>
        //                     <select id="month" placeholder="Select Exp. Month">
        //                         <option value="01">01</option>
        //                         <option value="02">02</option>
        //                         <option value="03">03</option>
        //                         <option value="04">04</option>
        //                         <option value="05">05</option>
        //                         <option value="06">06</option>
        //                         <option value="07">07</option>
        //                         <option value="08">08</option>
        //                         <option value="09">09</option>
        //                         <option value="10">10</option>
        //                         <option value="11">11</option>
        //                         <option value="12">12</option>
        //                     </select>
        //                     <select id="year" placeholder="Select Exp. Year">
        //                         {
        //                             years.map((year, index) => {
        //                                 return <option key={`year${index}`} value={year}>{year}</option>
        //                             })
        //                         }
        //                     </select>
        //                 </span>
        //             </div>
        //             <br />
        //             <div className="row">
        //                 <input type="text" id="phoneNumber" placeholder="Phone Number" />
        //                 <input type="text" id="cvv" placeholder="CVV" />
        //                 <button id="purchaseButton" onClick={purchaseClick}>Purchase</button>
        //             </div>                
        //         </div>
        //     );

            return (

<div className="bg-white shadow-lg rounded-2xl p-8 sm:w-[30rem] md:max-w-6xl h-[22em]  text-center ">
    <h1 className="text-3xl font-semibold mb-3 text-gray-800">Payment Terms</h1>
    <p className="text-gray-600 mb-3">Here are the payment terms on record for you:</p>
    <p className="text-gray-700 font-medium mb-6">{props.paymentMethod}</p>

    <input
        type="text"
        placeholder="Phone Number"
        className="w-full sm:w-3/4 border rounded-lg px-2 py-1 mb-6 focus:outline-none focus:ring-2 focus:ring-blue-500"
    />

    <div className="flex flex-col sm:flex-row gap-3 mt-2 justify-center items-center md:p-4">
        <button
            className="w-full sm:w-auto px-2 py-2 bg-gray-400 hover:bg-gray-300 text-gray-800 rounded-lg font-medium transition"
            onClick={quoteClick}
        >
            Quote Only
        </button>
        <button
            className="w-full sm:w-auto px-2 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium transition"
            onClick={handleOpen}
        >
            Place Order
        </button>
    </div>

    <Modal open={open} onClose={handleClose} >
        <div className="bg-white p-8 rounded-lg shadow-lg max-w-sm mx-auto mt-24">
            <Typography variant="h6" className="mb-6 text-gray-800">
                Would you like to place an Order or Invoice?
            </Typography>
            <div className="flex justify-between gap-6">
                <Button
                    variant="contained"
                    color="primary"
                    className="w-full"
                    onClick={orderClick}
                >
                    Order
                </Button>
                <Button
                    variant="contained"
                    color="secondary"
                    className="w-full"
                    onClick={invoiceClick}
                >
                    Invoice
                </Button>
            </div>
        </div>
    </Modal>
</div>


            )
        
    };

    return (

            <div  >{paymentBlockConditionalRender()}</div>
    );
}


export default PaymentBlock;